
import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action, Mutation } from 'vuex-class';
import rely from '../oauth2/oauth2rely';
import { Watch } from 'vue-property-decorator';
import config from '@/params/config';

@Component
export default class Head extends Vue {
  activeIndex: string = '';
  userName: string = '';
  shortName: string = '';
  showLogout: boolean = false;
  userIcon: string = '';
  userFlag: boolean = false;
  checked: boolean;
  routename: any = '';
  navList: any = require('./navconfig.json');
  aclList: any = require('./aclconfig.json');
  searchKey: string = '';

  @Getter hasBoardHead: any;
  @Action changesearchObj: (params: object) => void;
  @Action hasReportAccess: () => void;

  created() {
    this.aclhandle();
    this.boardHandle();
    this.activeIndex = (this.$route.meta && this.$route.meta.type) || 'home';
    // if (!this.searchKey && this.$route.meta.title === '全局搜索') {
    //   this.$router.push({ path: '/' });
    // }
    const user = localStorage.logonUser;
    if (!user) return false;
    const arr = JSON.parse(user).UserName.split('');
    if (arr.length > 3) {
      if (arr.indexOf('（') === -1) {
        this.userName = JSON.parse(user).UserName.split('(')[0];
      } else {
        this.userName = JSON.parse(user).UserName.split('（')[0];
      }
    } else {
      this.userName = JSON.parse(user).UserName;
    }
    this.shortName = arr[0];
    this.userIcon = JSON.parse(user).UserIcon;
  }

  // 后台管理标签
  aclhandle() {
    const user = JSON.parse(localStorage.logonUser);
    for (const item of this.aclList) {
      if (item.users.indexOf(user.UserCode) === -1) {
        delete this.navList[item.module];
      }
    }
  }

  // 运营看板标签
  boardHandle() {
    this.hasReportAccess();
  }

  @Watch('hasBoardHead.loading')
  watchMenuLoading(newVal: boolean, oldVal: boolean) {
    if (oldVal === true && newVal === false) {
      if (!this.hasBoardHead.access) {
        delete this.navList.board;
      }
    }
  }

  @Watch('$route.meta')
  handleRouteChange(val: any, oldVal: any) {
    if (val && val.type !== oldVal.type) this.activeIndex = val.type;
  }

  handleSearch() {
    const { title } = this.$route.meta;
    if (title !== '全局搜索') {
      this.$router.push({ path: '/home/globalSearch' });
    }
    this.changesearchObj({
      time: new Date().getTime(),
      searchKey: this.searchKey
    });
  }

  exit() {
    rely.logout();
  }

  handleLink(key: string) {
    const link = this.navList[key].link;
    const isExternal = /^(https?:|mailto:|tel:)/.test(link);
    if (link.indexOf('#') === 0) {
      this.activeIndex = key;
      this.$router.push({ path: '/' });
    } else if (isExternal) {
      window.open(link, '_blank');
    } else if(link.indexOf('upgrade') > -1){
      window.location.href = config.upgradeHost
    } else {
      this.$router.push({ path: link });
    }
  }

  handleClick(val: any) {
    this.$emit('watchMenuChange', val.key);
    if (val.key === 'linkout' && !!val.link) {
      window.open(val.link, '_blank');
    }
  }
}
